import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class ElementStatsResource extends AuthenticatedResource {
  static urlRoot = 'profile/:organization_slug/element_stats';

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}